import React, { type FC, type PropsWithChildren } from 'react';

import reactHTMLParser from '../../utils/reactHTMLParser';
import Box from '../box/box';
import type { Lucid } from '../../types/types';

export interface HtmlBlockProps {
  item: Lucid.Directus.Generated.Blog_Html;
  index?: number;
  sectionRefs?: React.MutableRefObject<HTMLHeadingElement[]>;
}

const HtmlBlock: FC<PropsWithChildren<HtmlBlockProps>> = ({ item, sectionRefs, index }) => (
  <Box
    key={item.id}
    ref={el => {
      if (sectionRefs && typeof index === 'number' && el) {
        sectionRefs.current[index] = el;
      }
    }}
    css={theme => [{ label: 'blogHtmlBlock' }, theme.shared.blogStyles(theme), theme.shared.htmlParserStyles(theme)]}
    id={`section_${item.id}`}
    onKeyDown={e => {
      if (e.key === 'ArrowLeft') {
        const element = document.querySelector(`#link_${item.id}_0`);
        (element as HTMLElement).focus();
      }
    }}
  >
    {reactHTMLParser(item.html, { replaceOptions: { headingItemId: item.id } })}
  </Box>
);

export default HtmlBlock;
export { HtmlBlock };
